module.exports = __webpack_public_path__ + "static/media/bullet.4132d09a.svg";